import { Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const LoginSignupToggle = ({
  isLoginMode,
  onLoginModeChange,
}: {
  isLoginMode: boolean
  onLoginModeChange: (login: boolean) => void
}) => {
  const { t } = useLocalization()

  return (
    <Row
      className={cn(
        'w-fit gap-1.5 rounded-[var(--radius-outer)] border p-2',
        'border-[hsl(var(--border-subtle))] bg-[hsl(var(--surface-panel)/0.88)] backdrop-blur-md'
      )}
    >
      <button
        type="button"
        onClick={() => onLoginModeChange(false)}
        className={cn(
          'rounded-[var(--radius-tab)] px-4 py-2 text-sm font-medium transition-all duration-200',
          !isLoginMode
            ? 'button-secondary text-foreground'
            : 'text-muted-foreground hover:bg-black/[0.045] hover:text-foreground/80'
        )}
      >
        {t('Sign up', 'Registrera dig')}
      </button>

      <button
        type="button"
        onClick={() => onLoginModeChange(true)}
        className={cn(
          'rounded-[var(--radius-tab)] px-4 py-2 text-sm font-medium transition-all duration-200',
          isLoginMode
            ? 'button-secondary text-foreground'
            : 'text-muted-foreground hover:bg-black/[0.045] hover:text-foreground/80'
        )}
      >
        {t('Log in', 'Logga in')}
      </button>
    </Row>
  )
}
